/**
 * Log errors to console and Splunk client logger.
 * Note that logging to Splunk is only allowed on the first error.
 * String substitution is not supported.
 * This should not be a problem since using a string template (`${foo}`) is not a computational issue for error logging.
 * However, if we want this feature in the future then we should consider adding it to zion-splunk-logger or in here (see format-util on npm).
 */
import { once } from 'lodash-es'
import { splunk } from '@fs/zion-splunk-logger'

const logErrorInSplunk = once((message) => splunk.error(message))

export default function logError(stringOrError) {
  // Avoid any issues with the splunk call.
  // Splunk call will throw if not a string or an object with keys (we don't need to support object with keys currently so just convert to a string)
  const message = stringOrError?.message || stringOrError || 'invalid_error_message'
  console.error(message)
  logErrorInSplunk(message)
}
